export function LabelIconText({icon, text, otherClass}) {

    return (
        <div className={otherClass}>
            {icon}
            <h3 className='ms-2 fw-bold'>{text}</h3>
        </div>
    );
}